<script lang="ts">
  import { randomFloat } from '../utils/math';

  interface Props {
    level?: number;
  }

  let { level = 0 }: Props = $props();

  const animationDelay = randomFloat(-10, 0);
</script>

<div class="face-outer die-level-{level}" style="--animation-delay: {animationDelay}s;">
  <div class="face-inner"></div>

  <div class="edge top">
    <div class="tick tick-1"></div>
    <div class="tick tick-2"></div>
  </div>
  <div class="edge bottom">
    <div class="tick tick-1"></div>
    <div class="tick tick-2"></div>
  </div>
  <div class="edge left">
    <div class="tick tick-1"></div>
    <div class="tick tick-2"></div>
  </div>
  <div class="edge right">
    <div class="tick tick-1"></div>
    <div class="tick tick-2"></div>
  </div>
</div>

<style lang="less">
  @import '../../defines.less';

  .face-outer {
    --dice-tick-size: 7px;
  }

  .die-level--1 {
    .tick-2 {
      display: none;
    }
  }
  .die-level-0 {
    .edge {
      display: none;
    }
  }
  .die-level-1 {
    .tick-2 {
      display: none;
    }
  }

  .edge {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    grid-gap: 5px;

    .tick {
      opacity: 0.8;
    }

    &.top {
      top: 0;
      height: var(--dice-tick-size);
      width: 100%;

      .tick {
        left: calc(50% - var(--dice-tick-size));
        right: calc(50% - var(--dice-tick-size));

        border-left: var(--dice-tick-size) solid transparent;
        border-right: var(--dice-tick-size) solid transparent;
        border-top: var(--dice-tick-size) solid #fff;
      }
    }
    &.bottom {
      bottom: 0;
      height: var(--dice-tick-size);
      width: 100%;

      .tick {
        left: calc(50% - var(--dice-tick-size));
        right: calc(50% - var(--dice-tick-size));

        border-left: var(--dice-tick-size) solid transparent;
        border-right: var(--dice-tick-size) solid transparent;
        border-bottom: var(--dice-tick-size) solid #fff;
      }
    }
    &.left {
      left: 0;
      width: var(--dice-tick-size);
      height: 100%;
      flex-direction: column;

      .tick {
        top: calc(50% - var(--dice-tick-size));
        bottom: calc(50% - var(--dice-tick-size));

        border-bottom: var(--dice-tick-size) solid transparent;
        border-top: var(--dice-tick-size) solid transparent;
        border-left: var(--dice-tick-size) solid #fff;
      }
    }
    &.right {
      right: 0;
      width: var(--dice-tick-size);
      height: 100%;
      flex-direction: column;

      .tick {
        top: calc(50% - var(--dice-tick-size));
        bottom: calc(50% - var(--dice-tick-size));

        border-bottom: var(--dice-tick-size) solid transparent;
        border-top: var(--dice-tick-size) solid transparent;
        border-right: var(--dice-tick-size) solid #fff;
      }
    }
  }

  .die-level--2,
  .die-level--1 {
    .edge {
      &.top {
        .tick {
          border-top: var(--dice-tick-size) solid black;
        }
      }
      &.bottom {
        .tick {
          border-bottom: var(--dice-tick-size) solid black;
        }
      }
      &.left {
        .tick {
          border-left: var(--dice-tick-size) solid black;
        }
      }
      &.right {
        .tick {
          border-right: var(--dice-tick-size) solid black;
        }
      }
    }
  }
</style>
